import { render, staticRenderFns } from "./ed-designer-elements-tools-item.component.vue?vue&type=template&id=7fa779a3&scoped=true&"
import script from "./ed-designer-elements-tools-item.component.ts?vue&type=script&lang=js&"
export * from "./ed-designer-elements-tools-item.component.ts?vue&type=script&lang=js&"
import style0 from "./ed-designer-elements-tools-item.component.scss?vue&type=style&index=0&id=7fa779a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa779a3",
  null
  
)

export default component.exports